export const dispatchWillUnmount = (vNode) => {
    if (vNode.type !== 'ELEMENT')
        return;
    vNode.children.forEach(dispatchWillUnmount);
    vNode.lifeEvents.willUnmount?.(vNode._el);
    vNode.lifeEvents.willUnmount = undefined;
};
